import { render, staticRenderFns } from "./PayMy.vue?vue&type=template&id=6058d3f6&"
import script from "./PayMy.vue?vue&type=script&lang=js&"
export * from "./PayMy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports